import { render, staticRenderFns } from "./Entry_relay.vue?vue&type=template&id=2adf3358"
import script from "./Entry_relay.vue?vue&type=script&lang=js"
export * from "./Entry_relay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports